import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import SocialMediaLinks from '../../../UI/SocialMediaLinks/SocialMediaLinks';
import classes from './Footer.module.css';

const Footer = ({ onBackToTop }) => {
  const history = useHistory();
  const backToHomeHandler = () => {
    history.push('/#home');
  };
  return (
    <div className={classes.footer}>
      <SocialMediaLinks color="black" />
      <div className={classes.buttonsContainer}>
        <button
          className={classes.button}
          onClick={backToHomeHandler}
          type="button"
        >
          Back To Home
        </button>
        <button className={classes.button} onClick={onBackToTop} type="button">
          Back To Top
        </button>
      </div>
    </div>
  );
};

Footer.propTypes = { onBackToTop: PropTypes.func.isRequired };

export default Footer;
